import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DataCollectionHeaderState = {
  isOpen: boolean;
  endsOn: string | null;
  endReason: string | null;
};

export type ParticipantStatusDetailState = {
  status: string | null;
  droppedOffOn: string | null;
  droppedOffReason: string | null;
  excludedOn: string | null;
  declinedOn: string | null;
  declinedReason: string | null;
};

export interface ParticipantTabState {
  categoryType: string;
  menuType: string;
  toggleLoader: boolean;
  assignable: boolean;
  isUnverified: boolean;
  dataCollection: DataCollectionHeaderState;
  statusDetail: ParticipantStatusDetailState;
}

const initialDataCollection: DataCollectionHeaderState = {
  isOpen: true,
  endsOn: null,
  endReason: null,
};

const initialStatusDetail: ParticipantStatusDetailState = {
  status: null,
  droppedOffOn: null,
  droppedOffReason: null,
  excludedOn: null,
  declinedOn: null,
  declinedReason: null,
};

const initialState: ParticipantTabState = {
  categoryType: "",
  menuType: "",
  toggleLoader: false,
  assignable: false,
  isUnverified: false,
  dataCollection: initialDataCollection,
  statusDetail: initialStatusDetail,
};

const getIntialState = (): ParticipantTabState => {
  const categoryType = sessionStorage?.getItem("category-type") ?? "";
  const menuType = sessionStorage?.getItem("menu-type") ?? "";
  return {
    ...initialState,
    categoryType,
    menuType,
  };
};

export const participantTabSlice = createSlice({
  name: "participantTab",
  initialState: getIntialState(),
  reducers: {
    setTabCategoryType: (state, action: PayloadAction<string>) => {
      state.categoryType = action.payload;
    },
    setTabMenuType: (state, action: PayloadAction<string>) => {
      state.menuType = action.payload;
    },
    setToggleLoader: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    setParticipantAssignable: (state, action: PayloadAction<boolean>) => {
      state.assignable = action.payload;
    },
    setIsUnverified: (state, action: PayloadAction<boolean>) => {
      state.isUnverified = action.payload;
    },
    setParticipantDataCollection: (
      state,
      action: PayloadAction<DataCollectionHeaderState>,
    ) => {
      state.dataCollection = action.payload;
    },
    setParticipantStatusDetail: (
      state,
      action: PayloadAction<ParticipantStatusDetailState>,
    ) => {
      state.statusDetail = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setTabCategoryType,
  setTabMenuType,
  setToggleLoader,
  setParticipantAssignable,
  setIsUnverified,
  setParticipantDataCollection,
  setParticipantStatusDetail,
  reset,
} = participantTabSlice.actions;

export default participantTabSlice.reducer;
